// src/views/socios/services/socios.api.js
import api from '@/api'

export async function fetchSocio(id) {
    const { data } = await api.get(`/users/${id}`)
    return data
}

export async function fetchMembresiasDeSocio(id) {
    const { data } = await api.get(`/membresia-usuarios/usuario/${id}`)
    return data
}

export async function fetchPagosDeSocio(id) {
    const { data } = await api.get(`/pagos-membresia/usuario/${id}`)
    return data
}
